import React from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { tutorialOpacity } from 'shared/utils/tutorial';
import styled, { css } from 'styled-components';
import { Modal } from 'react-bootstrap';
import Button from '../../../components/Button/Button';
import { pwaStyleAdapter } from '../../../utils/mobileSupported';
import useMissionInfo from 'shared/screens/Missions/hooks/useMissionInfo';

const MissionHelp = ({ activeTutorial, missionsAssets }) => {
  const {
    openModal,
    tutorialScreen,
    setOpenModal,
    handleOpenModal,
    findIndexScreen,
    handleBackScreen,
    handleFowardScreen,
  } = useMissionInfo({ missionsAssets });

  return (
    <Wrapper disabled={activeTutorial}>
      <HelpContainer>
        <div onClick={handleOpenModal}>
          <HelpImage src={missionsAssets.TUTORIAL_INFO_BUTTON} />
        </div>
      </HelpContainer>
      <Modal show={openModal} dialogClassName="battle-help-container modal-dialog-centered">
        <Modal.Body>
          <ModalContainer>
            <ImageBackground src={tutorialScreen} />
            <CloseButton
              onClick={() => setOpenModal(!openModal)}
              imageSource={assetSource(ASSET_KEY.CLOSE_BUTTON)}
            />
            <BackButton
              onClick={handleBackScreen}
              imageSource={assetSource(ASSET_KEY.BACK_ARROW)}
              display={findIndexScreen() === 0 ? 'none' : 'flex'}
            />
            <ForwardButton
              onClick={handleFowardScreen}
              imageSource={assetSource(ASSET_KEY.RIGHT_ARROW)}
              display={findIndexScreen() === 2 ? 'none' : 'flex'}
            />
          </ModalContainer>
        </Modal.Body>
      </Modal>
    </Wrapper>
  );
};

export default MissionHelp;

const windowWidth = window.innerWidth;

const Wrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['disabled'].includes(prop),
})`
  z-index: 5;
  opacity: ${({ disabled }) => tutorialOpacity(disabled)};
`;

const HelpContainerSmall = css`
  bottom: 2rem;
  left: 2rem;
`;
const HelpContainerRegular = css`
  top: ${pwaStyleAdapter(5.3, 'rem')};
`;

const HelpContainer = styled.div`
  position: absolute;
  flex: 1;
  z-index: 5;
  left: 1rem;
  z-index: 1000;
  ${isMobile && !isTablet ? HelpContainerSmall : HelpContainerRegular}
`;

const HelpImage = styled.img`
  cursor: pointer;
  height: 3.6rem;
  width: 3.6rem;
`;

const ModalContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const ImageBackground = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
`;

const CloseButton = styled(Button).attrs(({ theme }) => {
  let platformStyles = '';

  if (theme.screens.devices(['mobile-standalone', 'mobile-browser'])) {
    platformStyles = `
      top: 2.9vh;
      right: -1vw;
    `;
  } else if (theme.platform('ios') && theme.screens.devices(['tablet-browser', 'tablet-standalone'])) {
    platformStyles = `
      top: 2.8vh;
      right: -0.8vw;
    `;
  } else if (theme.platform('android') && theme.screens.devices(['tablet-browser', 'tablet-standalone'])) {
    platformStyles = `
      top: 2.6vh;
      right: -1vw;
    `;
  }

  return {
    containerStyle: `
      position: absolute;
      top: ${windowWidth < 1300 ? 2.5 : windowWidth < 1600 ? 2.8 : windowWidth < 1700 ? 2.5 : 2.1}vh;
      right: ${windowWidth < 1600 ? -0.7 : -1}vw;
      width: 4vw;
      cursor: pointer;
      z-index: 10;
      ${platformStyles}
    `,
    imageStyle: `
      width: 100%;
      object-fit: contain;
    `,
  };
})`
  cursor: pointer;
`;

const BackButton = styled(Button).attrs({
  containerStyle: `
  position: absolute;
  left: 2vw;
  width: 3vw;
  cursor: pointer;
  z-index: 1;
`,
  imageStyle: `
  width: 100%;
  object-fit: contain;
`,
})``;

const ForwardButton = styled(Button).attrs({
  containerStyle: `
  position: absolute;
  right: 2vw;
  width: 3vw;
  cursor: pointer;
  z-index: 1;
`,
  imageStyle: `
  width: 100%;
  object-fit: contain;
`,
})``;

